import React from 'react';
import Box from '@mui/material/Box';

const EmptyState = ({ icon, title, description, action }) => (
    <Box sx={{ px: '18px', py: '26px', textAlign: 'center', color: 'var(--muted)' }}>
        {icon && (
            <Box
                sx={{
                    width: 34,
                    height: 34,
                    borderRadius: '8px',
                    backgroundColor: 'var(--surface-2)',
                    border: '1px solid var(--line-2)',
                    display: 'grid',
                    placeItems: 'center',
                    mx: 'auto',
                    mb: 1.1,
                    color: 'var(--muted-2)',
                }}
            >
                {icon}
            </Box>
        )}
        {title && (
            <Box sx={{ display: 'block', fontSize: 12.5, fontWeight: 600, color: 'var(--ink)', mb: 0.4 }}>
                {title}
            </Box>
        )}
        {description && (
            <Box sx={{ fontSize: 11.5, maxWidth: 280, mx: 'auto', mb: action ? 1.4 : 0, lineHeight: 1.45 }}>
                {description}
            </Box>
        )}
        {action}
    </Box>
);

export default EmptyState;
